import React, { useEffect } from "react";
import Routes from "./Routes";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ClimateProvider } from "./contexts/ClimateContext";
import { ModalProvider } from "./contexts/ModalContext";
import ClimateEffects from "./components/effects/ClimateEffects";
import GlobalAIChat from "./components/GlobalAIChat";
import ConsultationModal from "./components/ui/ConsultationModal";
import { syncLocalStorageToSupabase } from "./lib/supabase";

function App() {
  useEffect(() => {
    // Try to sync any local storage data to Supabase when the application starts
    syncLocalStorageToSupabase().catch(err => {
      console.error("Auto-sync error:", err);
    });
  }, []);

  return (
    <ThemeProvider>
      <ModalProvider>
        <ClimateProvider>
          <ClimateEffects />
          <Routes />
          <GlobalAIChat />
          <ConsultationModal />
        </ClimateProvider>
      </ModalProvider>
    </ThemeProvider>
  );
}

export default App;
